import React from 'react';
import {alpha, makeStyles} from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MatSelect from '@material-ui/core/Select';
// import propTypes from 'prop-types';

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: '1px solid #e2e2e1',
    overflow: 'hidden',
    borderRadius: 4,
    backgroundColor: '#fcfcfb',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:hover': {
      backgroundColor: '#fff',
    },
    '&$focused': {
      backgroundColor: '#fff',
      boxShadow: `${alpha(theme.palette.primary.main, 0.2)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },
}));

Select.propTypes = {};

function Select({InputProps, label, options, ...props}) {
  const classesReddit = useStylesReddit();

  return (
    <FormControl fullWidth variant="filled">
      <InputLabel htmlFor="filled-age-native-simple">{label}</InputLabel>
      <MatSelect native disableUnderline className={classesReddit.root} InputProps={{...InputProps}} {...props}>
        <option aria-label="None" value="" />
        {options &&
          options.map((it, i) => (
            <option key={i} value={it.value}>
              {it.label}
            </option>
          ))}
      </MatSelect>
    </FormControl>
  );
}

export default Select;
